import React, { useEffect } from 'react';
import { useObserver } from 'mobx-react-lite';

import useTranslation from 'hooks/use-translation';
import { EmailForm } from 'src/payments/signup/views/email-form/email-form';
import useInstoreCart from 'hooks/use-instore-cart';
import { PasswordFormWrapper } from 'src/payments/instore-cart/views/login-form/password-form';
import { ResetPassword } from 'src/payments/instore-cart/views/login-form/reset-password';
import { LoginSteps } from 'src/payments/state/instore-cart';
import {
  useDutchiePayAnalytics,
  INSTORE_EVENTS,
} from 'src/payments/hooks/use-dutchie-pay-analytics/use-dutchie-pay-analytics';
import { LoginContentContainer } from './content-container';
import { useUserExistsCheck } from './use-user-exists-check';

export function LoginForm(): JSX.Element {
  const { t } = useTranslation();
  const InstoreCart = useInstoreCart();
  const { userExistsCheckQuery } = useUserExistsCheck();
  const { EMAIL, PASSWORD, RESET_PASSWORD } = LoginSteps;
  const currentLoginStep = useObserver(() => InstoreCart.currentLoginStep);
  const { dutchiePayEventTracker } = useDutchiePayAnalytics();

  const viewText = {
    email: {
      title: t('dutchiePay.email.title', 'Enter your email to continue'),
      subTitle: t('dutchiePay.email.subtitle', 'We’ll check to see if you already have an account.'),
    },
  };

  useEffect(() => {
    dutchiePayEventTracker(INSTORE_EVENTS.LOGIN_VIEWED, { loginStep: currentLoginStep });
  }, [currentLoginStep, dutchiePayEventTracker]);

  const onForgotPasswordClose = (): void => InstoreCart.setCurrentLoginStep(LoginSteps.EMAIL);

  const steps = {
    [EMAIL]: (
      <EmailForm
        onSubmit={userExistsCheckQuery}
        titleText={viewText.email.title}
        subtitleText={viewText.email.subTitle}
      />
    ),
    [PASSWORD]: <PasswordFormWrapper showToolTip={false} />,
    [RESET_PASSWORD]: <ResetPassword onClose={onForgotPasswordClose} />,
  };

  return <LoginContentContainer>{steps[currentLoginStep]}</LoginContentContainer>;
}
